import React from 'react'

import { BaseLottie } from './Base'
import { generateDefaultOptions } from './config'
import ConfettiJSON from './json/confetti.json'

const defaultOptions = generateDefaultOptions(ConfettiJSON)

const Confetti = () => {
    return <BaseLottie options={defaultOptions} />
}

export { Confetti }
